// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".defaultViewStyle[data-v-bf46a0b4] {\n  background-size: cover;\n  background-repeat: no-repeat;\n  display: flex;\n  align-items: center;\n}\n.defaultViewStyle .login-panel[data-v-bf46a0b4] {\n  width: 100%;\n  text-align: center;\n}\n.defaultViewStyle .login-panel .login-tip[data-v-bf46a0b4] {\n  color: #909399;\n  font-size: 0.37333rem;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
